import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import * as firebase from 'firebase';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  // styleUrls: ['./authentication.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AuthenticationComponent {

  constructor(public authService:AuthService, private router: Router ) {}
  returnUrl:String;

  ngOnInit() {
    if( history.state.route === '/cart'){
      this.returnUrl =  '/check-out';
    }else{
      this.returnUrl =  history.state.route;
    }
  }
}
